import { render, staticRenderFns } from "./ImportCustomersFromFileModal.vue?vue&type=template&id=4956bfcb&scoped=true&"
import script from "./ImportCustomersFromFileModal.vue?vue&type=script&lang=js&"
export * from "./ImportCustomersFromFileModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportCustomersFromFileModal.vue?vue&type=style&index=0&id=4956bfcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956bfcb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardActions,VCol,VDialog,VFileInput,VRow,VToolbar,VToolbarTitle})
